import AbstractModel from './AbstractModel'
import Mapper from './mapper/Mapper'
import Column from './table/Column'

class RegistroTitolare extends AbstractModel {
  permission () {
    return {
      'USR': {
        action: { isInsertable: false, isEditable: true, isDeletable: false },
        columns: {}
      },
      'ADM': {
        action: { isImpersonate: false, isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      }
    }
  }
  mapper () {
    return [
      Mapper.column.azienda(true)
    ]
  }
  columns () {
    return [
      new Column('btn').withHtml(true).withWidth('100px').withIsEditable(false).withIsInsertable(false).withExportable(false),
      new Column('idazi').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('id').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('uo').withType('text'),
      new Column('denonominazione').withType('text'),
      new Column('finalita').withType('text'),
      new Column('software').withType('text'),
      new Column('contitolare').withType('text'),
      new Column('cat_interessati').withType('text'),
      new Column('cat_dati_personali').withType('text'),
      new Column('cat_destinatari').withType('text'),
      new Column('responsabili_esterni').withType('text'),
      new Column('paesi_terzi').withType('text'),
      new Column('garanzie_adottate').withType('text'),
      new Column('periodo_conservazione').withType('text'),
      new Column('misure_adottate').withType('text'),
      new Column('articolo6').withType('text'),
      new Column('articolo9').withType('text'),
      new Column('tipologia_trattamento').withType('text'),
      new Column('fonte_dati').withType('text'),
      new Column('consenso_interessati').withType('text'),
      new Column('modalita_conservazione').withType('text'),
      new Column('valutazione_richiesta').withType('text'),
      new Column('fase_valutazione').withType('text'),
      new Column('dpia').withType('text'),
      new Column('username_creazione').withType('text'),
      new Column('timestamp_creazione').withType('text'),
      new Column('username_modifica').withType('text'),
      new Column('timestamp_modifica').withType('text'),
      new Column('tipo_record').withType('text')
    ]
  }

  validator () {
    return {
      idazi: { required: true, type: 'number' },
      ambito: { required: true, type: 'string' },
      dexdpi: { required: true, type: 'string' },
      marcamodello: { required: true, type: 'string' },
      mansione: { required: true, type: 'string' },
      fattore: { required: true, type: 'string' }
    }
  }
}

export default new RegistroTitolare()
